/** O owner operacional vigente é o Module CRM/prospect/leads. A autorização
 * continua sendo a presença desse Module no menu autorizado da sessão. */
export const CRM_OPERATIONAL_MODULE = Object.freeze({ product: 'admindigital', category: 'crm', domain: 'prospect', module: 'leads' });

/** @param {{menuModules?: Array<{product?:string, category?:string, domain?:string, module?:string}>, moduleRef?: object|null}} input */
export const isCrmOperationalAvailable = ({ menuModules = [], moduleRef = CRM_OPERATIONAL_MODULE } = {}) => {
  if (!moduleRef) return false;
  return (Array.isArray(menuModules) ? menuModules : []).some((item) => ['product', 'category', 'domain', 'module'].every((key) => !moduleRef[key] || item?.[key] === moduleRef[key]));
};

const hasCandidate = ({ record = {} } = {}) => Boolean(record.candidate_id || record.candidateId);
const hasCandidateTenant = ({ record = {} } = {}) => Boolean(record.candidate_tenant_id || record.candidateTenantId);

const hasDossierWindow = ({ record = {} } = {}) => {
  const next = record.dossier_next_refresh_at;
  const date = next ? new Date(next) : null;
  return Boolean(date && Number.isFinite(date.getTime()));
};
const dossierRefreshOpen = (context = {}, now = new Date()) => hasDossierWindow(context) && new Date(context.record.dossier_next_refresh_at) <= now;

/**
 * Ações por linha, conforme o pacote CRM do tenant (entitlement efetivo ∩ autorização operacional; hoje o sinal disponível à interface é o Module Leads no menu autorizado da sessão):
 *   SEM CRM  Editar · Ver Dossiê (estados finais) · Atualizar Dossiê (só APARECE após 180 dias da primeira avaliação ou da última atualização) · SEM "Enviar para o CRM".
 *   COM CRM  Editar · Enviar para o CRM (habilita só em `prospect`) · SEM Ver/Atualizar Dossiê nesta grade (ficam no contexto do CRM, reutilizando o mesmo Dossiê).
 * O backend revalida sessão, tenant, estado, prazo e execução única, independentemente da interface.
 */
export const candidateActionStates = (context = {}, options = {}, now = new Date()) => {
  const crm = isCrmOperationalAvailable(options);
  const candidate = hasCandidate(context);
  return {
    dossier: { visible: candidate && !crm, enabled: candidate && !crm },
    // Sem janela aberta (antes de 180 dias, sem primeira avaliação ou sem data) o botão NÃO aparece: nunca desabilitado.
    refreshDossier: { visible: candidate && !crm && dossierRefreshOpen(context, now), enabled: candidate && !crm && dossierRefreshOpen(context, now) },
    sendToCrm: { visible: candidate && crm, enabled: candidate && hasCandidateTenant(context) && crm && context?.record?.state === 'prospect' },
  };
};

/** Ações de Dossiê no contexto do CRM (Leads): Ver sempre que o Lead tem Candidate; Atualizar só com a janela de 180 dias aberta (nunca desabilitado). */
export const leadDossierActionStates = (context = {}, now = new Date()) => {
  const candidate = hasCandidate(context);
  const open = candidate && dossierRefreshOpen(context, now);
  return { dossier: { visible: candidate, enabled: candidate }, refreshDossier: { visible: open, enabled: open } };
};
